import React, { useState, useEffect } from 'react';
import { LogOut, Settings } from 'lucide-react';
import { Link } from 'react-router-dom';
import { axiosInstance } from '@/axiosConfig'; // Importante para o Logout funcionar

export default function UserWidget() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Função para buscar o usuário do storage
    const checkUser = () => {
      const userStr = localStorage.getItem('user');
      // Só atualiza se houver mudança para evitar re-renders desnecessários
      if (userStr) {
        const parsedUser = JSON.parse(userStr);
        // Compara ID simples para ver se é o mesmo usuário (opcional, mas boa prática)
        setUser((prev) => {
            if (prev && prev.id === parsedUser.id) return prev;
            return parsedUser;
        });
      }
    };

    // 1. Tenta buscar imediatamente
    checkUser();

    // 2. Configura um intervalo para verificar periodicamente
    // Isso resolve o problema de o App.js demorar um pouco para salvar o cookie no storage
    const intervalId = setInterval(checkUser, 1000);

    // Limpa o intervalo ao desmontar o componente
    return () => clearInterval(intervalId);
  }, []);

  const handleLogout = async () => {
    try {
      // 1. Avisa o backend para destruir o cookie HttpOnly
      await axiosInstance.post('/auth/logout'); 
    } catch (error) {
      console.error("Erro silencioso no logout", error);
    } finally {
      // 2. Limpa dados visuais do navegador
      localStorage.removeItem('user'); 
      
      // 3. Força o redirecionamento para login (Hard Reload)
      window.location.href = '/login';
    }
  };

  // === ESTADO DE CARREGAMENTO (SKELETON) ===
  // Mostra isso enquanto o App.js ainda está validando o cookie
  if (!user) {
    return (
      <div className="border-t border-b border-gray-700 py-4 mb-4 px-2 animate-pulse">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-gray-600"></div>
          <div className="flex-1 space-y-2">
             <div className="h-3 bg-gray-600 rounded w-20"></div>
             <div className="h-2 bg-gray-600 rounded w-14"></div>
          </div>
        </div>
      </div>
    );
  }

  // === LÓGICA DE EXIBIÇÃO ===
  const displayName = user.vendedor_nome || user.username || "Usuário";

  let roleName = "Colaborador"; 
  if (user.is_superuser) {
      roleName = "Super Admin";
  } else if (user.role === 'admin') {
      roleName = "Administrador";
  } else if (user.role === 'financeiro') {
      roleName = "Financeiro";
  }

  return (
    <div className="border-t border-b border-gray-700 py-4 mb-4">
      
      {/* Informações do Usuário */}
      <div className="flex items-center gap-3 mb-3 px-2">
        <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white font-bold text-lg shrink-0 border border-blue-500 shadow-sm">
           {displayName.charAt(0).toUpperCase()}
        </div>
        
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium text-white truncate" title={displayName}>
            {displayName}
          </p>
          <p className="text-xs text-gray-400 truncate">
            {roleName}
          </p>
        </div>
      </div>

      {/* Botões de Ação (Perfil e Sair) */}
      <div className="flex items-center justify-between mt-2 px-3">
        
        {/* Link para o Perfil */}
        <Link 
          to="/perfil" 
          className="flex items-center text-xs text-blue-400 hover:text-blue-300 transition-colors"
          title="Editar Perfil"
        >
          <Settings className="w-3 h-3 mr-1" /> 
          Meu Perfil
        </Link>

        {/* Botão Sair */}
        <button 
          onClick={handleLogout}
          className="flex items-center text-xs text-red-400 hover:text-red-300 transition-colors cursor-pointer"
        >
          <LogOut className="w-3 h-3 mr-1" /> 
          Sair
        </button>
      </div>

    </div>
  );
}